"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecentralandNotificationType = exports.NotificationActiveTab = void 0;
var NotificationActiveTab;
(function (NotificationActiveTab) {
    NotificationActiveTab["NEWEST"] = "newest";
    NotificationActiveTab["READ"] = "read";
})(NotificationActiveTab = exports.NotificationActiveTab || (exports.NotificationActiveTab = {}));
var DecentralandNotificationType;
(function (DecentralandNotificationType) {
    DecentralandNotificationType["ITEM_SOLD"] = "item_sold";
    DecentralandNotificationType["ROYALTIES_EARNED"] = "royalties_earned";
    DecentralandNotificationType["BID_ACCEPTED"] = "bid_accepted";
    DecentralandNotificationType["BID_RECEIVED"] = "bid_received";
    DecentralandNotificationType["GOVERNANCE_ANNOUNCEMENT"] = "governance_announcement";
    DecentralandNotificationType["GOVERNANCE_PROPOSAL_ENACTED"] = "governance_proposal_enacted";
    DecentralandNotificationType["GOVERNANCE_COAUTHOR_REQUESTED"] = "governance_coauthor_requested";
    DecentralandNotificationType["GOVERNANCE_AUTHORED_PROPOSAL_FINISHED"] = "governance_authored_proposal_finished";
    DecentralandNotificationType["GOVERNANCE_VOTING_ENDED_VOTER"] = "governance_voting_ended_voter";
    DecentralandNotificationType["GOVERNANCE_NEW_COMMENT_ON_PROPOSAL"] = "governance_new_comment_on_proposal";
    DecentralandNotificationType["GOVERNANCE_NEW_COMMENT_ON_PROJECT_UPDATE"] = "governance_new_comment_on_project_update";
    DecentralandNotificationType["WORLDS_MISSING_RESOURCES"] = "worlds_missing_resources";
    DecentralandNotificationType["WORLDS_ACCESS_RESTRICTED"] = "worlds_access_restricted";
    DecentralandNotificationType["WORLDS_ACCESS_RESTORED"] = "worlds_access_restored";
    DecentralandNotificationType["LAND_RENTED"] = "rental_started";
    DecentralandNotificationType["LAND_RENTAL_ENDED"] = "rental_ended";
    DecentralandNotificationType["REWARD_ASSIGNED"] = "rewards_assignment";
    DecentralandNotificationType["EVENTS_STARTS_SOON"] = "events_starts_soon";
    DecentralandNotificationType["EVENTS_STARTED"] = "events_started";
})(DecentralandNotificationType = exports.DecentralandNotificationType || (exports.DecentralandNotificationType = {}));
